// extracted by mini-css-extract-plugin
export var author = "RelatedContent-module--author--724a6";
export var backgroundImage = "RelatedContent-module--backgroundImage--31877";
export var date = "RelatedContent-module--date--c4b39";
export var excerpt = "RelatedContent-module--excerpt--7a431";
export var featuredImage = "RelatedContent-module--featuredImage--8a93b";
export var featuredImageRemote = "RelatedContent-module--featuredImageRemote--8daef";
export var filters = "RelatedContent-module--filters--bdfc4";
export var heading = "RelatedContent-module--heading--5332d";
export var loadMore = "RelatedContent-module--loadMore--1f572";
export var loadMoreButton = "RelatedContent-module--loadMoreButton--9d6d1";
export var postItemCode = "RelatedContent-module--postItemCode--c2e7c";
export var postItemConsulting = "RelatedContent-module--postItemConsulting--21973";
export var postItemContent = "RelatedContent-module--postItemContent--3e7c7";
export var postItemEducation = "RelatedContent-module--postItemEducation--03ba1";
export var postItemInnerWrapper = "RelatedContent-module--postItemInnerWrapper--407d1";
export var postItemWrapper = "RelatedContent-module--postItemWrapper--ec4a8";
export var postList = "RelatedContent-module--postList--e4807";
export var tag = "RelatedContent-module--tag--1c60f";
export var tagList = "RelatedContent-module--tagList--3724c";
export var title = "RelatedContent-module--title--18345";
export var titleWrapper = "RelatedContent-module--titleWrapper--30e64";
export var wrapper = "RelatedContent-module--wrapper--b8f38";